function loadJSFile(container, url, { content, attributes } = {}) {
  return new Promise(function(resolve, reject) {
    var element = document.createElement('script');
    element.type = 'text/javascript';
    if (url) {
      element.addEventListener('load', resolve, false);
      element.addEventListener('error', reject, false);
      element.src = url;
    }
    if (content) {
      element.text = content;
    }
    if (attributes) {
      Object.keys(attributes).forEach(key => {
        element.setAttribute(key, attributes[key]);
      });
    }
    container.appendChild(element);

    if (!url) {
      resolve();
    }
  });
}

export default loadJSFile;
